<template>
  <div>
    <StructureTable
      :items="items"
      :headers="headers"
      :totalItems="totalSiteGroups"
      :loading="loading"
      @getItems="handleGetSiteGroups"
      @edit="handleEdit"
    />
    <EditSitesGroupDialog
      :organizationId="organizationId"
      :sitesGroup="selectedSitesGroup"
      :visible="showEditDialog"
      :loading="loading || saving"
      @close="handleClose"
      @save="saveSiteGroup"
    />
  </div>
</template>

<script>
import _ from 'lodash'
import StructureTable from '../../Shared/StructureTable.vue'

import EditSitesGroupDialog from './EditSitesGroupDialog.vue'

import api from '@/api'
import mixin from '@/mixins/mixin.vue'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'SiteGroupsGroupstab',

  mixins: [mixin],

  components: {
    StructureTable,
    EditSitesGroupDialog,
  },

  props: {
    organizationId: String,
    loading: Boolean,
    siteGroups: { type: Array, required: true },
    totalSiteGroups: { type: Number, required: true },
  },

  data() {
    return {
      saving: false,
      selectedSitesGroup: null,
      showEditDialog: false,
      options: {},
      headers: [
        {
          text: _.capitalize(this.$t('common.site_group_one')),
          align: 'start',
          sortable: true,
          value: 'name',
          show: true,
          width: '100px',
        },
        {
          text: _.capitalize(this.$t('common.site_other')),
          sortable: false,
          value: 'sitesSample',
          align: 'start',
          show: true,
          width: '100px',
        },
        {
          text: _.capitalize(this.$t('common.action_other')),
          sortable: false,
          value: 'actions',
          align: 'center',
          show: true,
          width: '80px',
        },
      ],
    }
  },

  computed: {
    ...mapGetters(['account']),

    items() {
      return this.siteGroups.map(siteGroup => {
        return {
          ...siteGroup,
          id: siteGroup._id,
        }
      })
    },
  },

  methods: {
    ...mapActions(['getOrganizationStructure']),

    handleGetSiteGroups(options) {
      this.options = options
      this.$emit('getSiteGroups', options)
    },

    async saveSiteGroup(siteGroup) {
      this.saving = true
      try {
        if (!_.isEqual(siteGroup.sites, this.selectedSitesGroup.sites))
          await api.sitegroups.editSites(this.organizationId, siteGroup.id, {
            sites: siteGroup.sites,
          })

        await api.sitegroups.update(
          this.organizationId,
          siteGroup.id,
          siteGroup
        )

        this.selectedSitesGroup = null
        this.showEditDialog = false
        if (this.account?.organization?._id === this.organizationId) {
          await this.getOrganizationStructure({
            organizationId: this.organizationId,
          })
        }
        this.$emit('getSiteGroups', this.options)
        this.$emit('getSites')
        this.$emit('cleanSearchTerm')
      } catch (err) {
        this.handleRequestError(err)
      } finally {
        this.saving = false
      }
    },

    handleClose() {
      this.selectedSitesGroup = null
      this.showEditDialog = false
    },

    handleEdit(siteGroup) {
      this.selectedSitesGroup = siteGroup
      this.showEditDialog = true
    },
  },
}
</script>
